import { Kit, KitStatus } from '../models/customerOverview';
import { defaultLang } from '../hoc/i18n/i18n';

export const parseJWT = (token: string) => {
  let base64Url = token.split('.')[1];
  base64Url = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const base64 = decodeURIComponent(atob(base64Url).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));
  return JSON.parse(base64);
};

export const filterArrayByKey = (array: any[], needle: string) => {
  let result = '';
  array.forEach(i => {
    if (i[needle]) {
      result = i[needle];
    }
  });
  return result;
};

export const filterArrayByValue = (array: any[], needle: string, value: string) => {
  let result = '';
  array.forEach(i => {
    if (i[needle] && i[needle] === value) {
      result = i;
    }
  });
  return result;
};

export const hasValue = (str: string) => {
  if (str === '' || str === null || str === undefined) {
    return false;
  }
  return true;
};

export const stripHypen = (str: string) => str.replace(/-/g, '');

export function getCurrentAppLang(partnerPrefix = false) {
  const currentLang = localStorage.getItem('i18nextLng') || defaultLang();
  const partner = localStorage.getItem('partner');
  if (!partner && currentLang) {
    localStorage.setItem('partner', currentLang.split('_')[0]);
  }
  return partnerPrefix ? (currentLang || 'tasscare_en-HK') : (currentLang?.replace(`${partner}_`, '') || 'en-HK');
}

export function addedKitTest(kits: Kit[], kitStatus: KitStatus): Kit[] {
  switch (kitStatus) {
    case 'report-ready':
      const testAdded = kits.map(function (kitInfo) {
        const newKitTest = Object.assign({}, kitInfo);
        newKitTest.test = [{
          datetime: '',
          extractedId: '',
          id: '',
          kitId: '',
          orderId: '',
          owner: '',
          primaryId: '',
          status: kitStatus,
          files: [],
          testId: '',
          name: '',
          history: [],
        }];
        return newKitTest;
      });
      return testAdded;
    case 'report-result-ready':
      const resultReady = kits.map(function (kitInfo) {
        const newKitTest = Object.assign({}, kitInfo);
        newKitTest.test = [{
          datetime: '',
          extractedId: '',
          id: '',
          kitId: '',
          orderId: '',
          owner: '',
          primaryId: '',
          status: kitStatus,
          files: [],
          testId: '',
          name: '',
          history: [],
        }];
        return newKitTest;
      });
      return resultReady;
    default:
      return kits;

  }

}